module.exports = __webpack_public_path__ + "static/img/404.5caabc44.png";